export const SHOW_VALIDATION_ERROR_NOTIFICATION =
  "SHOW_VALIDATION_ERROR_NOTIFICATION";
export const SHOW_REQUEST_ERROR_NOTIFICATION =
  "SHOW_REQUEST_ERROR_NOTIFICATION";
export const SHOW_SUCCESS_NOTIFICATION = "SHOW_SUCCESS_NOTIFICATION";
export const SHOW_ERROR_NOTIFICATION = "SHOW_ERROR_NOTIFICATION";
export const SHOW_WARNING_NOTIFICATION = "SHOW_WARNING_NOTIFICATION";
